import { getUrl, getApi } from './api'
import { getReq, postReq } from './appService'

// 获取艺术品列表
export const getArtworks = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/nfts', chainId, params)
  getReq(url, cb)
}

// 获取艺术品列表V2
export const getArtworksV2 = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v2/nfts'
  postReq(url, params, cb)
}
// 获取艺术品列表V2
export const getArtworksV3 = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v3/nfts'
  postReq(url, params, cb)
}
// 获取BmoncNft列表
export const getBmoncNftList = (params: any, cb: any) => {
  const url = 'https://video.binamon.org/cards'
  postReq(url, params, cb)
}
// Launch Artworks
export const createArtworks = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/artworks'
  postReq(url, params, cb)
}

// audit Artworks
export const auditArtworks = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/artworks/audit'
  postReq(url, params, cb)
}

// 获取BakeryCombos
export const getBakeryCombos = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/combos', chainId, params)
  getReq(url, cb)
}

// V2获取BakeryCombos
export const getBakeryCombosV2 = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v2/combos', chainId, params)
  getReq(url, cb)
}

// V2获取BakeryCombos
export const getBakeryCombosV3 = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v3/combos', chainId, params)
  getReq(url, cb)
}

// 获取Pets NFT列表
export const getPets = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/pets/nfts', chainId, params)
  getReq(url, cb)
}

// V2获取Pets NFT列表
export const getPetsV2 = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v2/pets/nfts', chainId, params)
  getReq(url, cb)
}

// V2获取Pets NFT列表
export const getPetsV3 = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v3/pets/nfts', chainId, params)
  getReq(url, cb)
}

// 获取Helmets NFT列表
export const getHelmets = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/helmets/nfts', chainId, params)
  getReq(url, cb)
}

// Auction
export const setAuction = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/auction/price'
  postReq(url, params, cb)
}
// 获取tarding列表
export const getEvents = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v1/nfts/events', chainId, params)
  getReq(url, cb)
}

// 获取my-binance-nft
export const getMyBinanceNFT = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/nfts'
  postReq(url, params, cb)
}
// 获取my-binance-nft V2
export const getMyBinanceNFTV2 = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v2/nfts'
  postReq(url, params, cb)
}

// 设置竞拍价格
export const setMaxBidPrice = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/auction/bid'
  postReq(url, params, cb)
}

// 获取首页卖的最好的nft前十列表
export const getBestNfts = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v3/nfts', chainId, params)
  getReq(url, cb)
}


// 设置竞拍价格
export const getCollection = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/collections'
  postReq(url, params, cb)
}


// 获取weapon，combo，pet，petEgg详情
export const getGameInfo = (chainId: number, params: any, cb: any) => {
  let url = getUrl(params.url, chainId, {ids: `${params.ids}`})
  getReq(url, cb)
}

// 获取weapon，combo，pet，petEgg列表
export const getGameList = (chainId: number, params: any, cb: any) => {
  let url = getUrl(params.url, chainId, params.others)
  getReq(url, cb)
}